module.exports = __webpack_public_path__ + "img/titel-bild.fad85564.jpg";